class PlanPickerMenobacsEs extends HTMLElement {
  connectedCallback() {
    this.classList.remove('hidden');
    this.variantSelects = this.closest('variant-selects');

    this.querySelectorAll('.menobacs-card').forEach((card) => {
      card.addEventListener('click', () => this.selectCard(card));
    });

    this.onVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (data?.sectionId !== this.dataset.section) return;
      this.syncPurchaseTypeAfterVariantUpdate();
    });

    this.init();
    this.initOnetimeCta();
  }

  disconnectedCallback() {
    this.onVariantChangeUnsubscriber?.();
  }

  placeMenobacsLayout(onetime, infoRow) {
    const submitButton = this.getProductForm()?.querySelector('[type="submit"]');
    const buyButtons = submitButton?.closest('.product__buy-buttons');

    if (onetime && buyButtons) {
      buyButtons.insertAdjacentElement('beforebegin', onetime);
      onetime.classList.add('menobacs-onetime--above');
    }

    if (infoRow && submitButton) {
      submitButton.insertAdjacentElement('afterend', infoRow);
    }
  }

  initOnetimeCta() {
    const onetime = this.querySelector('[data-menobacs-onetime]');
    if (!onetime) return;

    const submitButton = this.getProductForm()?.querySelector('[type="submit"]');
    if (this.hasAttribute('data-es-reverted')) {
      this.placeMenobacsLayout(onetime, this.querySelector('[data-menobacs-info]'));
    } else if (submitButton) {
      submitButton.insertAdjacentElement('afterend', onetime);
    }

    const infoButton = onetime.querySelector('.menobacs-onetime__info');
    const tooltip = onetime.querySelector('.menobacs-onetime__tooltip');
    const ctaButton = onetime.querySelector('.menobacs-onetime__cta');

    if (infoButton && tooltip) {
      const positionTooltipArrow = () => {
        const iconRect = infoButton.getBoundingClientRect();
        const rowRect = onetime.getBoundingClientRect();
        const arrowLeft = iconRect.left + iconRect.width / 2 - rowRect.left;
        tooltip.style.setProperty('--menobacs-tooltip-arrow-left', `${arrowLeft}px`);
      };

      infoButton.addEventListener('click', (event) => {
        event.preventDefault();
        const isOpen = infoButton.getAttribute('aria-expanded') === 'true';
        infoButton.setAttribute('aria-expanded', String(!isOpen));
        tooltip.hidden = isOpen;
        if (!isOpen) positionTooltipArrow();
      });

      document.addEventListener('click', (event) => {
        if (!onetime.contains(event.target)) {
          infoButton.setAttribute('aria-expanded', 'false');
          tooltip.hidden = true;
        }
      });

      document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
          infoButton.setAttribute('aria-expanded', 'false');
          tooltip.hidden = true;
        }
      });
    }

    if (ctaButton) {
      ctaButton.addEventListener('click', async (event) => {
        event.preventDefault();
        const variantId = ctaButton.dataset.variantId;
        if (!variantId || ctaButton.disabled) return;

        ctaButton.disabled = true;

        const formEl = this.getProductFormElement();
        const parentUid = formEl?.querySelector('input[name="properties[_parent_uid]"]')?.value;
        const giftsInput = formEl?.querySelector('input[name="properties[_gifts]"]');

        const body = { id: variantId, quantity: 1 };
        if (giftsInput && parentUid) {
          body.properties = { _gifts: 'true', _parent_uid: parentUid };
        }

        const response = await AjaxCart.addToCart(JSON.stringify(body), 'menobacs-es-onetime');

        const giftModal = response?.properties?._gifts
          ? document.getElementById(`PopupModal-Gifts-${response.properties._parent_uid}`)
          : null;

        if (giftModal) {
          giftModal.show();
        } else {
          setTimeout(() => CartItems.cartDrawerRenderContent(), 300);
        }

        ctaButton.disabled = false;
      });
    }
  }

  init() {
    const params = new URLSearchParams(window.location.search);
    const variantParam = params.get('variant');

    if (variantParam) {
      const matchingInfo = this.variantSelects?.querySelector(
        `.option__info[data-variant-id="${variantParam}"]`
      );
      if (matchingInfo) {
        const type = matchingInfo.dataset.type;
        const nameEl = matchingInfo.querySelector('.option__info-name span.h5');
        const optionName = nameEl?.textContent.trim();
        if (optionName && type) {
          const escapedName = optionName.replace(/"/g, '\\"');
          const card = this.querySelector(
            `.menobacs-card[data-type="${type}"][data-value="${escapedName}"]`
          );
          if (card) {
            this.selectCard(card);
            return;
          }
        }
      }
    }

    if (window.isGoogleAdsCampaignTraffic?.()) {
      const firstCard = this.querySelector('.menobacs-card');
      if (firstCard) this.selectCard(firstCard);
      return;
    }

    const currentSelect = parseInt(this.variantSelects?.dataset.currentSelect || '0', 10);
    if (currentSelect > 0) {
      const packageFieldset = this.variantSelects?.querySelector('.product-options_package');
      const checkedInput = packageFieldset?.querySelector('input[type="radio"]:checked');
      const label = checkedInput ? packageFieldset?.querySelector(`label[for="${checkedInput.id}"]`) : null;
      const optionInfo = label?.querySelector('.option__info:not(.hidden)');

      if (optionInfo) {
        const type = optionInfo.dataset.type;
        const nameEl = optionInfo.querySelector('.option__info-name span.h5');
        const optionName = nameEl?.textContent.trim();

        if (optionName && type) {
          const escapedName = optionName.replace(/"/g, '\\"');
          const card = this.querySelector(
            `.menobacs-card[data-type="${type}"][data-value="${escapedName}"]`
          );
          if (card) {
            this.selectCard(card);
            return;
          }
        }
      }
    }

    const preselectedCard = this.querySelector('.menobacs-card.active') || this.querySelector('.menobacs-card');
    if (preselectedCard) this.selectCard(preselectedCard);
  }

  selectCard(card) {
    if (!card) return;

    const type = card.dataset.type;

    this.querySelectorAll('.menobacs-card').forEach((c) => c.classList.remove('active'));
    card.classList.add('active');
    this.dataset.currentType = type;

    this.variantSelects?.lockSubmitUntilVariantSettled?.();
    this.variantSelects?.updatePurchaseTypeInput?.(type);
    this.variantSelects?.toggleProductFormInput?.(type);

    this.variantSelects?.querySelectorAll('.option__info').forEach((info) => {
      info.classList.toggle('hidden', info.dataset.type !== type);
    });

    this.variantSelects?.querySelectorAll('.variant-option_package').forEach((option) => {
      const hasType = option.querySelectorAll(`[data-type="${type}"]`).length > 0;
      option.classList.toggle('hidden', !hasType);
    });

    // Write id / selling_plan into the form immediately. The section refetch
    // that follows can take several seconds on this PDP; ATC must not wait for it.
    this.syncFormToCard(card);
    this.triggerRadioForCard(card);
    this.syncFormToCard(card);

    const giftOptionWrapper = this.variantSelects?.querySelector('.option__info-gifts-wrapper');
    if (giftOptionWrapper) {
      giftOptionWrapper.classList.toggle('hidden', type === 'onetimer');
    }

    this.syncPurchaseTypeAfterVariantUpdate();
    this.unlockAddToCart();
  }

  syncPurchaseTypeAfterVariantUpdate() {
    const type = this.dataset.currentType;
    if (!type) return;

    this.variantSelects?.updatePurchaseTypeInput?.(type);
    this.variantSelects?.toggleProductFormInput?.(type);

    const sectionId = this.dataset.section;
    document.querySelector(`product-form[data-section-id="${sectionId}"]`)?.togglePrices?.();
  }

  getProductForm() {
    const sectionId = this.dataset.section;
    return (
      this.closest('product-info')?.querySelector(`product-form[data-section-id="${sectionId}"]`) ||
      this.closest('product-info')?.querySelector('product-form') ||
      document.querySelector(`product-form[data-section-id="${sectionId}"]`) ||
      document.querySelector('product-form')
    );
  }

  getProductFormElement() {
    const productForm = this.getProductForm();
    return (
      productForm?.querySelector('form') ||
      document.getElementById(`product-form-${this.dataset.section}`)
    );
  }

  syncFormToCard(card) {
    const form = this.getProductFormElement();
    if (!form) return;

    const variantId = card.dataset.variantId;
    const type = card.dataset.type;
    const sellingPlanId = card.dataset.sellingPlanId;

    form.querySelectorAll('input[name="id"]').forEach((input) => {
      if (variantId) input.value = variantId;
    });

    const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    if (sellingPlanInput) {
      if (type === 'onetimer') {
        sellingPlanInput.setAttribute('disabled', 'disabled');
      } else {
        sellingPlanInput.removeAttribute('disabled');
        if (sellingPlanId) sellingPlanInput.value = sellingPlanId;
      }
    }

    this.getProductForm()?.separateProductsLogic?.();

    const strikeEl = form.querySelector('.menobacs-atc-strike');
    if (strikeEl) {
      const strikePrice = card.dataset.strikePrice;
      if (strikePrice) {
        strikeEl.textContent = strikePrice;
        strikeEl.hidden = false;
      } else {
        strikeEl.hidden = true;
        strikeEl.textContent = '';
      }
    }

    const priceMainEl = form.querySelector('.atc-price_main');
    const cardPrice = card.dataset.price;
    if (priceMainEl && cardPrice) {
      priceMainEl.textContent = cardPrice;
      priceMainEl.dataset.onetimerPrice = cardPrice;
      priceMainEl.dataset.subscriptionPrice = cardPrice;
    }
  }

  unlockAddToCart() {
    const productForm = this.getProductForm();
    if (!productForm) return;

    if (typeof productForm.unlockForVariantChangeIfIdle === 'function') {
      productForm.unlockForVariantChangeIfIdle();
    } else {
      productForm.toggleSubmitButton?.(false);
    }
  }

  getRadioForCard(card) {
    if (!this.variantSelects) return null;

    const type = card.dataset.type;
    const variantId = card.dataset.variantId;
    const optionName = card.dataset.value;
    let optionInfo = null;

    if (variantId) {
      optionInfo = this.variantSelects.querySelector(
        `.option__info[data-type="${type}"][data-variant-id="${variantId}"]`
      );
    }

    if (!optionInfo && optionName) {
      const optionInfos = this.variantSelects.querySelectorAll(`.option__info[data-type="${type}"]`);
      for (const info of optionInfos) {
        const nameEl = info.querySelector('.option__info-name span.h5');
        if (nameEl?.textContent.trim() === optionName) {
          optionInfo = info;
          break;
        }
      }
    }

    const label = optionInfo?.closest('label, .variant-option_package');
    const inputId = label?.getAttribute('for');
    return inputId ? document.getElementById(inputId) : null;
  }

  triggerRadioForCard(card) {
    const input = this.getRadioForCard(card);
    if (!input) return;

    const alreadyChecked = input.checked;
    input.checked = true;
    if (!alreadyChecked) {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

customElements.define('plan-picker-menobacs-es', PlanPickerMenobacsEs);
